import { render, staticRenderFns } from "./orderPdLists.vue?vue&type=template&id=5ff22bb8&scoped=true&"
import script from "./orderPdLists.vue?vue&type=script&lang=js&"
export * from "./orderPdLists.vue?vue&type=script&lang=js&"
import style0 from "./orderPdLists.vue?vue&type=style&index=0&id=5ff22bb8&scoped=true&lang=css&"
import style1 from "./orderPdLists.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff22bb8",
  null
  
)

export default component.exports